// actions
export const FETCH_PRICE_TRACKS = 'price-tracks/FETCH_PRICE_TRACKS';
export const FETCH_PRICE_TRACK = 'price-tracks/FETCH_PRICE_TRACK';
export const ADD_PRICE_TRACK = 'price-tracks/ADD_PRICE_TRACK';
export const FETCH_FILTERED_MEMBERS_ANALYSIS_PRICE_TRACK = 'price-tracks/FETCH_FILTERED_MEMBERS_ANALYSIS_PRICE_TRACK';
export const FETCH_FILTERED_MEMBERS_ANALYSIS_PAST_PERFORMANCE_PRICE_TRACK =
'price-tracks/FETCH_FILTERED_MEMBERS_ANALYSIS_PAST_PERFORMANCE_PRICE_TRACK';
export const FETCH_CHARTDATA_PRICE_TRACK = 'provider/FETCH_CHARTDATA_PRICE_TRACK';
export const FETCH_MEMBERS_ANALYSIS_PRICE_TRACK = 'members/FETCH_MEMBERS_ANALYSIS_PRICE_TRACK';
